module.exports = __webpack_public_path__ + "media/images/icon_user3-9fc21a88d6d9ffd695a5528db4d16bbe.png";